(function () {
  document.documentElement.classList.add('mg-storey-ready');

  function setupDesktopHoverMenus() {
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var cleanupCallbacks = [];

    function cleanup() {
      cleanupCallbacks.forEach(function (callback) {
        callback();
      });
      cleanupCallbacks = [];
    }

    function enableHoverMenus() {
      cleanup();

      if (!desktopQuery.matches) {
        return;
      }

      document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
        var openMenu = function () {
          details.setAttribute('open', '');
        };

        var closeMenu = function () {
          details.removeAttribute('open');
        };

        var closeWhenFocusLeaves = function () {
          window.setTimeout(function () {
            if (!details.contains(document.activeElement)) {
              closeMenu();
            }
          }, 0);
        };

        var closeOnEscape = function (event) {
          if (event.key === 'Escape') {
            closeMenu();
          }
        };

        details.addEventListener('mouseenter', openMenu);
        details.addEventListener('mouseleave', closeMenu);
        details.addEventListener('focusin', openMenu);
        details.addEventListener('focusout', closeWhenFocusLeaves);
        details.addEventListener('keydown', closeOnEscape);

        cleanupCallbacks.push(function () {
          details.removeEventListener('mouseenter', openMenu);
          details.removeEventListener('mouseleave', closeMenu);
          details.removeEventListener('focusin', openMenu);
          details.removeEventListener('focusout', closeWhenFocusLeaves);
          details.removeEventListener('keydown', closeOnEscape);
        });
      });
    }

    enableHoverMenus();
    desktopQuery.addEventListener('change', enableHoverMenus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDesktopHoverMenus);
  } else {
    setupDesktopHoverMenus();
  }
})();